import { useIsMobile } from './useIsMobile';
import { isNative } from '@/platform/platform';

/**
 * ¿El dispositivo actual prefiere la experiencia de ADMIN (escritorio) frente a
 * la de ALUMNO (app/móvil)? Solo importa para el usuario dual "alumno + admin
 * de empresa" (ver [[getHomeRoute]]).
 *
 * Regla: app nativa (Capacitor) o viewport móvil → alumno; escritorio web →
 * admin. `isNative()` es estable en runtime; el ancho sí reacciona vía
 * `useIsMobile`, así que redimensionar la ventana re-evalúa la preferencia.
 */
export function usePrefersAdminExperience(): boolean {
  const isMobile = useIsMobile();
  return !isNative() && !isMobile;
}
